import {
  React,
  Component,
  ReactDOM,
  Cookies,
  CookiesProvider,
  Route,
  Switch,
  Router,
  createHistory,
} from 'imports/CommonImports';

import {
  HomeView,
  ProjectsView,
  ProjectView,
  ProfileView,
  SelectionView,
  ProjectPostulationView,
  PostulationListView,
  PostulationThanksView,
  ManagerSetupView,
  ConsultantView,
  PortfolioView,
  PortfolioSetupView,
  ResetPasswordView,
  CompanyView,
  EditFileView,
  SignatureView,
  WorkshopView,
  EconomicSelectionView,
  InnspiralView,
  DashboardSummaryView,
  DashboardProjectsView,
  DashboardAreaView,
  UtilitiesView,
} from 'imports/ViewsImports';

import {
  NotFound,
  Forbidden,
  Authorization,
  StageValidator,
  Landing,
  Appointment,
  App
} from 'imports/ComponentsImports';

import {
  PrimaryColor1,
  PrimaryColor2,
  SuccessColor,
  FailureColor,
  ShadowColor,
  GreyColor1,
  GreyColor2,
} from 'imports/DesignImports';

import 'index.css';
// React 16 Map, Set and Polyfill
import 'core-js/es6/map';
import 'core-js/es6/set';

import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';

import 'flexboxgrid/css/flexboxgrid.css';

// Create a history of your choosing (we're using a browser history in this case)
const history = createHistory();

const myMuiTheme = getMuiTheme({
  fontFamily: 'Lato, sans-serif',
  palette: {
    primary1Color: PrimaryColor1,
    primary2Color: PrimaryColor2,
    accent1Color: SuccessColor,
    accent2Color: ShadowColor,
    textColor: PrimaryColor1,
    canvasColor: GreyColor1,
    borderColor: GreyColor1,
    disabledColor: PrimaryColor2,
    shadowColor: ShadowColor,
  },
  stepper: {
    iconColor: PrimaryColor1,
    inactiveIconColor: PrimaryColor2,
    textColor: PrimaryColor1,
    disabledTextColor: PrimaryColor2,
  },
  drawer: {
    color: '#FFFFFF',
  },
  dropDownMenu: {
    accentColor: PrimaryColor1,
  },
  menuItem: {
    selectedTextColor: FailureColor,
  },
  datePicker: {
    color: PrimaryColor1,
    textColor: '#FFFFFF',
    selectColor: PrimaryColor1,
    calendarYearBackgroundColor: '#FFFFFF',
    headerColor: PrimaryColor1,
  },
  paper: {
    backgroundColor: GreyColor2,
  },
});

// Router configuration
const All = Authorization(['Líder de proyecto', 'Gerente de área', 'Gerente Innovación', 'Innspiral', 'Control de gestión', 'Admin']);
const Innspiral = Authorization(['Innspiral']);
const Managers = Authorization(['Gerente Innovación', 'Gerente de área']);
const Admin = Authorization(['Gerente Innovación', 'Innspiral']);
const Anyone = Authorization(['Anyone']);
const SuperAdmin = Authorization(['Admin']);

// Stage control
const Setup = StageValidator(1, 4);
const SetupPortfolio = StageValidator(5, 5);
const Portfolio = StageValidator(5, 10);
const Postulation = StageValidator(6, 6);
const Selection = StageValidator(7, 7);
const Workshop = StageValidator(8, 8);
const Files = StageValidator(9, 9);
const EconomicSelection = StageValidator(10, 10);
const Dashboard = StageValidator(11, 12);



export default class Index extends Component {
  constructor(props){
    super(props);
    this.state = {
      cookies: new Cookies()
    }
  }

  render(){
    return(
        <CookiesProvider>
          <MuiThemeProvider muiTheme={myMuiTheme}>
            <Router history={history}>
              <Switch>
                <Route exact path="/" render={(props) => <Landing registerCookie={this.registerCookie} getCookie={this.getCookie} history={props.history}/>} />
                <App getCookie={this.getCookie} removeCookie={this.removeCookie}>
                  <Route path="/home" component={All(HomeView)} />
                  <Route path="/consultant" component={Innspiral(ConsultantView)} />
                  <Route path="/manager_criteria" component={Setup(Managers(ManagerSetupView))} />
                  {/*<Route path="/committee_criteria" component={Setup(Admin(CommitteeSetupView))}/>*/} 
                  <Route exact path="/company/:id" component={Setup(All(CompanyView))} />
                  <Route exact path="/company/:id/setup" component={Setup(Admin(ManagerSetupView))} />

                  <Route path="/portfolio/setup" component={SetupPortfolio(Admin(PortfolioSetupView))} />

                  <Route exact path="/portfolio" component={Portfolio(All(PortfolioView))} />

                  <Route path="/project_postulation/:hash" component={Anyone(ProjectPostulationView)} />
                  <Route path="/portfolio/postulation/projects" component={Postulation(All(PostulationListView))} />
                  <Route path="/portfolio/postulation/thanks" component={Anyone(PostulationThanksView)} />

                  <Route path="/portfolio/selection" component={Selection(Admin(SelectionView))} />

                  <Route path="/portfolio/workshop" component={Workshop(Admin(WorkshopView))} />

                  <Route path="/portfolio/files" component={Files(All(ProjectsView))} />
                  <Route exact path="/project/:id/edit" component={Innspiral(EditFileView)} />
                  <Route exact path="/project/:id" component={Files(All(ProjectView))} />
                  <Route path="/signatures" component={Files(All(SignatureView))} />

                  <Route path="/portfolio/economic_selection" component={EconomicSelection(Admin(EconomicSelectionView))} />

                  <Route path="/dashboard/summary" component={Dashboard(Admin(DashboardSummaryView))} />
                  <Route path="/dashboard/by_projects" component={Dashboard(Admin(DashboardProjectsView))} />
                  <Route path="/dashboard/by_area" component={Dashboard(Admin(DashboardAreaView))} />

                  <Route path="/utilities" component={SuperAdmin(UtilitiesView)} />

                  <Route path="/reset_password/:token" component={Anyone(ResetPasswordView)} />
                  <Route path="/profile/:id" component={All(ProfileView)} />
                  <Route path="/innspiral_home" component={Innspiral(InnspiralView)} />
                  <Route path="/appointment" component={All(Appointment)} />
                  <Route path="/forbidden" component={All(Forbidden)} />
                </App>
                <Route component={NotFound}/>
              </Switch>
            </Router>
          </MuiThemeProvider>
        </CookiesProvider>
    );
  }
  registerCookie = (key, value) => {
    this.state.cookies.set(key, JSON.stringify(value), { path: '/' });
  }

  getCookie = (key) => {
    return this.state.cookies.get(key);
  }

  removeCookie = (key) => {
    this.state.cookies.remove(key, { path: '/' });
  }
}


ReactDOM.render(<Index/>
  ,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js